import { render } from "./addArticle.vue?vue&type=template&id=7ddff176"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__